module.exports = __webpack_public_path__ + "img/1121.d858f894.gif";